import { backendGet, backendPost, backendPut } from '../lib/backendClient';

export async function getMyStore() {
  return await backendGet('/api/restaurants/stores/my');
}

export async function createStore(storeData) {
  return await backendPost('/api/restaurants/stores', storeData);
}

export async function updateStore(storeId, storeData) {
  return await backendPut(`/api/restaurants/stores/${storeId}`, storeData);
}

export async function toggleStoreStatus(storeId, isOpen) {
  return await backendPut(`/api/restaurants/stores/${storeId}`, {
    is_open: isOpen
  });
}

export const STORE_CATEGORIES = [
  'Pizza',
  'Hamburguer',
  'Japones',
  'Italiana',
  'Brasileira',
  'Saudavel',
  'Doces',
  'Bebidas',
  'Mercado',
  'Conveniencia',
  'Padaria',
  'Salgados',
  'Lanchonete',
  'Frutos do Mar',
  'Vegana',
  'Mexicana',
  'Arabe',
  'Chinesa',
  'Outro'
];

export const DEFAULT_OPENING_HOURS = {
  monday: { open: '09:00', close: '22:00', closed: false },
  tuesday: { open: '09:00', close: '22:00', closed: false },
  wednesday: { open: '09:00', close: '22:00', closed: false },
  thursday: { open: '09:00', close: '22:00', closed: false },
  friday: { open: '09:00', close: '22:00', closed: false },
  saturday: { open: '09:00', close: '23:00', closed: false },
  sunday: { open: '09:00', close: '20:00', closed: false }
};

export const DAYS_OF_WEEK = {
  monday: 'Segunda-feira',
  tuesday: 'Terca-feira',
  wednesday: 'Quarta-feira',
  thursday: 'Quinta-feira',
  friday: 'Sexta-feira',
  saturday: 'Sabado',
  sunday: 'Domingo'
};
